// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3ryKT","dragIcon":"SortableItem_dragIcon__2dtAg","disabled":"SortableItem_disabled__2vV-P"};